import api, { authService } from './api';

export const phonesService = {
  listPhones: async ({ q, limit = 5000 } = {}) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.get('/phones', {
        params: { q, limit },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        items: response.data.items || [],
        totalCount: response.data.total_count || 0,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to fetch phone numbers',
      };
    }
  },

  createPhone: async (payload) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.post('/phones', payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        item: response.data.item,
        message: response.data.message,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to create phone number',
      };
    }
  },

  updatePhone: async (phoneId, payload) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.patch(`/phones/${encodeURIComponent(phoneId)}`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        item: response.data.item,
        message: response.data.message,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to update phone number',
      };
    }
  },
};
